(function () {
  'use strict';
  if (window.SilberthalJarFinderLoader) return;
  window.SilberthalJarFinderLoader = true;
  var loading;
  var waiting = new WeakSet();

  function script(url) {
    return new Promise(function (resolve, reject) {
      var node = document.createElement('script');
      node.src = url;
      node.async = true;
      node.onload = resolve;
      node.onerror = function () { node.remove(); reject(new Error('script_load')); };
      document.head.append(node);
    });
  }
  function load(root) {
    if (window.SilberthalJarFinderUI) {
      window.SilberthalJarFinderUI.mount(root);
      return Promise.resolve();
    }
    if (!loading) {
      loading = (window.SilberthalJarFinder ? Promise.resolve() : script(root.dataset.vgfLogicUrl))
        .then(function () { return script(root.dataset.vgfUiUrl); })
        .then(function () {
          if (!window.SilberthalJarFinderUI) throw new Error('init_failed');
        }).catch(function (error) { loading = null; throw error; });
    }
    return loading.then(function () { window.SilberthalJarFinderUI.mount(root); });
  }
  function startButton(event) {
    return event.target instanceof Element && event.target.closest('[data-vgf-start]');
  }
  function prepare(event) {
    var button = startButton(event);
    if (!button) return;
    var root = button.closest('[data-vgf]');
    if (root && !root.dataset.vgfReady) load(root).catch(function () { /* A click offers a retry. */ });
  }
  document.addEventListener('pointerover', prepare, { passive: true });
  document.addEventListener('focusin', prepare);
  document.addEventListener('click', function (event) {
    var button = startButton(event);
    if (!button) return;
    var root = button.closest('[data-vgf]');
    if (!root || root.dataset.vgfReady) return;
    // Capture the first click while loading, then deliver it exactly once to the ready controller.
    event.preventDefault();
    event.stopImmediatePropagation();
    if (waiting.has(root)) return;
    waiting.add(root);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    var status = root.querySelector('[data-vgf-load-error]');
    if (status) status.textContent = '';
    load(root).then(function () {
      if (!root.dataset.vgfReady) throw new Error('init_failed');
      button.disabled = false;
      button.removeAttribute('aria-busy');
      if (root.isConnected) button.click();
    }).catch(function () {
      if (status) status.textContent = 'Der Finder konnte gerade nicht geladen werden. Bitte versuche es erneut oder nutze den Größenguide unten.';
    }).finally(function () {
      waiting.delete(root);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
  }, true);
})();
